export default "__VITE_ASSET__b2Ux9Zbc__"